import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PostPreview from "../components/postPreview";
import CosmicController from "../controllers/cosmicController";
import Spinner from "../components/spinner";
import PostMetaHead from "../components/postMetaHead";

const PostPage = () => {
	const { slug } = useParams();
	const [post, setPost] = useState(null);
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const getPostBySlug = async () => {
			setLoading(true);

			try {
				const response = await CosmicController.getPostBySlug(slug);

				if (!response.success) {
					throw new Error(response.message);
				}

				setPost(response.data);
			} catch (error) {
				setError("При подгрузке поста произошла ошибка");
			} finally {
				setLoading(false);
			}
		};

		getPostBySlug();
	}, [slug]);

	if (loading) {
		return <Spinner />;
	}

	if (error) {
		return <p>{error}</p>;
	}

	if (!post || !post.metadata) {
		return null;
	}

	return (
		<>
			<PostMetaHead post={post} />
			<PostPreview post={post} />
		</>
	);
};

export default PostPage;
